<script lang="ts">
import type { AvatarImageEmits, AvatarImageProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

export interface AvatarImagePropsWithClass extends AvatarImageProps {
  alt: string
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core'
import { AvatarImage, useForwardPropsEmits } from 'reka-ui'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<AvatarImagePropsWithClass>()
const emits = defineEmits<AvatarImageEmits>()

const delegatedProps = reactiveOmit(props, 'class', 'alt')
const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <AvatarImage
    data-slot="avatar-image"
    v-bind="forwarded"
    :alt="props.alt"
    :role="props.alt === '' ? 'presentation' : 'img'"
    :class="cn('aspect-square size-full object-cover', props.class)"
  />
</template>
